// Season-Deskriptoren (Konzept §4).
//
// Eine Season ist erst dann "vorhanden", wenn Topologie, Fahrplan und Regeln
// gemeinsam gebaut und getestet sind. Deshalb steht hier bewusst nur S1. Ein
// zweiter Datensatz mit derselben Karte wäre keine Rotation, sondern ein Label.
// Der Deskriptor bündelt trotzdem die Identität, die Client, Server,
// Persistenz und persönliche Chronik gemeinsam brauchen.

export const SEASONS = Object.freeze({
  S1: Object.freeze({
    id: 'S1',
    name: 'Kupferkorridor',
    epochMs: Date.UTC(2026, 6, 26, 0, 0, 0),
    seed: 0x5eed1a7e,
    timeScale: 12,
    topology: 'copper-corridor-v1',
    rules: Object.freeze({
      climate: 'southwest',
      coldMultiplier: 1.0,
      weatherBias: 1.0,
      radioRangeMultiplier: 1.0,
    }),
  }),
});

export const ACTIVE_SEASON = SEASONS.S1;

/** Unbekannte IDs nie still auf eine andere Welt abbilden. */
export function seasonById(id) {
  return SEASONS[id] ?? null;
}
